/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { accessAPI, Titulo, SubidorArchivos } from "../../shared";
import { Card } from "primereact/card";

export default function MuestraUpload() {
  const { hashUpload } = useParams();
  const [muestra, setMuestra] = useState(null);
  const [error, setError] = useState(null);
  const [cantidadSubidas, setCantidadSubidas] = useState(0);

  useEffect(() => {
    if (!hashUpload) return;
    accessAPI(
      "GET",
      `muestra/upload/${hashUpload}`,
      null,
      (resp) => setMuestra(resp),
      (resp) => setError(resp?.[0]?.msg || "Link inválido"),
    );
  }, [hashUpload]);

  const fondo = { background: "var(--principal)", minHeight: "calc(100vh - var(--alturaFooter))" };

  if (error) {
    return (
      <div css={fondo}>
        <div css={{ padding: "1.5em", maxWidth: "600px", margin: "0 auto" }}>
          <Card>
            <Titulo>Link inválido</Titulo>
            <p>{error}</p>
          </Card>
        </div>
      </div>
    );
  }

  if (!muestra) {
    return (
      <div css={fondo}>
        <div css={{ padding: "1.5em", maxWidth: "600px", margin: "0 auto" }}>
          <Card>
            <p>Cargando…</p>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div css={fondo}>
      <div css={{ padding: "1.5em", maxWidth: "600px", margin: "0 auto" }}>
        <Titulo>Muestra {muestra.numero}</Titulo>
        <Card>
          <p css={{ marginTop: 0 }}>
            <strong>Producto:</strong> {muestra.productoEtiqueta || "—"}
          </p>
          <p>
            Tomá fotos con la cámara o elegí imágenes de la galería para
            agregarlas a esta muestra.
          </p>

          <SubidorArchivos
            presignEndpoint={`muestra/upload/${hashUpload}/presign`}
            confirmarEndpoint={`muestra/upload/${hashUpload}/imagenes/confirmar`}
            ubicacion="muestrasimagenes"
            multiple
            accept="image/*"
            // En mobile abre la cámara directamente; en desktop muestra el
            // selector de archivos como siempre.
            capture="environment"
            chooseLabel="Tomar / elegir imágenes"
            onSubido={(creados) =>
              setCantidadSubidas((n) => n + creados.length)
            }
          />

          {cantidadSubidas > 0 && (
            <p css={{ marginTop: "1em", color: "var(--verde)" }}>
              Imágenes subidas en esta sesión: <strong>{cantidadSubidas}</strong>
            </p>
          )}
        </Card>
      </div>
    </div>
  );
}
